import { Component, Vue, Watch } from "vue-property-decorator";
import { Alert } from "ant-design-vue";
import { isAnyVersionSelected } from "@/util/func";
import { fmtMsg } from "commonui";
import { CommonLocale } from "@/locales/localeid";
import { VersionGroupModule } from "@/modules/versiongroup";

@Component({
	components: {
		Alert
	}
})
export default class NoVersionGroupAlert extends Vue {
	private versionGroupModule = VersionGroupModule; // For watch need to create local reference
	public noVersion: boolean = false;
	get commonLocale(): any {
		return CommonLocale;
	}
	created() {
		if (!isAnyVersionSelected()) {
			this.noVersion = true;
		}
	}
	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}
	@Watch("versionGroupModule.selectedGsVersion")
	@Watch("versionGroupModule.selectedLsVersion")
	isVersionUpdated() {
		this.noVersion = !isAnyVersionSelected();
	}
}
